<div class="desktop-full-screen-overlay--flex payment-dialog">
  <div>
    <app-form-container [title]="'webPos.OfflineCardPayment' | translate" class="sale-trip__dialog-form-container"
      (onCancel)="onCancel()" (onSubmit)="onConfirm()" [confirmDisabled]="!isFormValid()">
      <ng-container form-body [formGroup]="confirmForm">
        <div class="sale-trip__dialog-pay-form">

          @if (offlinePaymentDisplayName) {
          <div class="sale-trip__dialog-pay-value">
            <span>{{ 'webPos.PaymentType' | translate }}: {{ offlinePaymentDisplayName }}</span>
          </div>
          }

          @if (hasPresetAmount) {
          <div class="dialog__offline-summary">
            <span>{{ 'webPos.ValueToPay' | translate }}: {{ presetAmountFormatted }}</span>
          </div>
          } @else {
          <div class="dialog__input-container">
            <app-form-input label="webPos.ValueToPay"
              [placeholder]="'webPos.ValueToPay' | translate"
              [type]="FormInputType.Number"
              formControlName="amountToPay">
            </app-form-input>
            <span class="input__suffix">{{ stateService.currencyCode() | currencymap }} </span>
          </div>
          }

          <div class="dialog__label dialog__label--offline">
            {{ 'webPos.OfflinePaymentInstructions' | translate }}
          </div>

          <!-- <div class="dialog__input-container">
            <app-form-input label="webPos.CardPrefix" [placeholder]="'webPos.CardPrefix' | translate"
              [type]="FormInputType.Text" [maxLength]="6" [numericOnly]="true" formControlName="cardPrefix">
            </app-form-input>
          </div> -->

          <div class="dialog__input-container">
            <app-form-input label="webPos.CardSuffix" [placeholder]="'webPos.CardSuffix' | translate"
              [type]="FormInputType.Text" [maxLength]="4" [numericOnly]="true" formControlName="cardSuffix">
            </app-form-input>
          </div>

          <div class="dialog__input-container">
            <app-form-input label="webPos.AuthorizationCode" [placeholder]="'webPos.AuthorizationCode' | translate"
              [type]="FormInputType.Text" [maxLength]="6" [numericOnly]="false" formControlName="authorizationCode">
            </app-form-input>
          </div>

          @if (canUseOverpaymentOverride()) {
          <div class="dialog__checkbox-container">
            <input type="checkbox" id="AllowOverpaymentOfflineCheckbox" class="dialog__checkbox" formControlName="allowOverpayment" />
            <label for="AllowOverpaymentOfflineCheckbox" class="dialog__checkbox-label">{{ 'webPos.AllowOverpayment' | translate }}</label>
          </div>
          }

          @if (isOverpaymentOverrideEnabled()) {
          <app-form-input [label]="'webPos.OverpaymentReason' | translate"
            [placeholder]="'webPos.OverpaymentReasonPlaceholder' | translate"
            [type]="FormInputType.Textarea" formControlName="overpaymentReason" [maxLength]="500">
          </app-form-input>
          }

        </div>
      </ng-container>
    </app-form-container>
  </div>
</div>
